import type { OutlookSpace, TimeStreamProjects } from 'owa-timestream-types';
import getProjectId from '../../utils/getProjectId';

export default function markUnknownProjectsAsDeleted(
    projects: TimeStreamProjects,
    tenant: string,
    mailbox: string,
    validSpaces: OutlookSpace[]
) {
    const validProjectIds = validSpaces.reduce(
        (a, { id }) => ((a[getProjectId(tenant, mailbox, id)] = true), a),
        {}
    );

    projects.forEach(project => {
        if (project.tenant == tenant && project.mailbox == mailbox) {
            if (!validProjectIds[project.projectId]) {
                project.deleted = true;
            }
        }
    });
}
